import React from 'react';
import styles from './ButtonCard.module.css';
import ArrowIcon from '../icons/ArrowIcon';

const ButtonCard = ({
  title,
  description,
  rightIcon = null,
  onClick,
  className,
  disabled = false,
  backgroundColor = 'var(--color-primary)',
}) => {
  return (
    <div className={`${styles.buttonCustom} ${className}`} onClick={onClick} disabled={disabled}>
      <div className='fw-600'>{title}</div>
      <div className='font-smaller mt-1'>{description}</div>
      <div className='text-right mt-auto'>
        <ArrowIcon color={'#000'} size={14} rotate={45} />
      </div>
    </div>
  );
};

export default ButtonCard;
